/**
 * ĐĂNG NHẬP.
 *
 * Gắn `device_id` ngay lúc đăng nhập: lần đầu thì hệ thống tự gắn, lần sau
 * đối chiếu. Máy khác máy đã đăng ký thì VẪN cho vào — nhưng báo rõ để nhân
 * viên biết chấm công sẽ bị trừ điểm, và hướng dẫn tạo yêu cầu đổi máy
 * (docs/02 §2.7).
 */

import { useState } from 'react'

import { ApiError } from '../api/loi'
import { dangNhap, nhanVienHienTai } from '../services/auth.service'
import { layDeviceId } from '../lib/thietbi'

export default function DangNhap({
  onXong,
}: {
  /** `phaiDoiMatKhau` = server bắt đổi mật khẩu trước khi dùng (docs/14 §14.3). */
  onXong: (phaiDoiMatKhau: boolean) => void
}) {
  const [ma, setMa] = useState('')
  const [matKhau, setMatKhau] = useState('')
  const [dangGui, setDangGui] = useState(false)
  const [loi, setLoi] = useState<string | null>(null)
  const [canhBaoThietBi, setCanhBaoThietBi] = useState(false)

  const gui = async (e: React.FormEvent) => {
    e.preventDefault()
    setDangGui(true)
    setLoi(null)
    try {
      const kq = await dangNhap(ma.trim().toUpperCase(), matKhau, layDeviceId())
      const phaiDoi = Boolean(kq.employee.must_change_password)
      if (!kq.employee.device_matches) {
        // Không chặn — nhưng phải nói rõ, nếu không nhân viên sẽ ngơ ngác khi
        // bản ghi rơi vào chờ duyệt mà không hiểu vì sao.
        setCanhBaoThietBi(true)
        setDangGui(false)
        return
      }
      onXong(phaiDoi)
    } catch (err) {
      if (err instanceof ApiError) {
        const conLai = (err.detail as { con_lai?: number })?.con_lai
        setLoi(
          conLai !== undefined && conLai <= 3
            ? `${err.message}. Còn ${conLai} lần trước khi khoá tài khoản.`
            : err.message,
        )
      } else if (err instanceof TypeError && /fetch/i.test(err.message)) {
        // `TypeError: Failed to fetch` là lỗi mạng THẬT — request đã rời máy
        // nhưng không tới nơi.
        setLoi('Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại.')
      } else {
        // Mọi thứ còn lại là lỗi TRONG trình duyệt, không phải mạng. Trước
        // đây gộp hết vào câu "kiểm tra mạng" và đã đổ oan cho hạ tầng suốt
        // một buổi khi `crypto.randomUUID` vắng mặt ngoài secure context
        // (docs/13 §13.4). Hiện nguyên văn lỗi ra — xấu nhưng thật.
        setLoi(
          `Lỗi trong ứng dụng, không phải lỗi mạng: ${
            err instanceof Error ? err.message : String(err)
          }. Báo quản trị kèm nguyên văn dòng này.`,
        )
      }
      setDangGui(false)
    }
  }

  if (canhBaoThietBi) {
    return (
      <div className="man-hinh dang-nhap">
        <div className="canh-bao-thiet-bi" role="alert">
          <h2>Điện thoại này chưa được đăng ký</h2>
          <p>
            Bạn đã đăng ký một điện thoại khác. Vẫn chấm công được, nhưng bản
            ghi sẽ <strong>chờ quản lý duyệt</strong> thay vì hợp lệ ngay.
          </p>
          <p className="ghi-chu">
            Nếu đây là máy mới, vào mục <strong>Yêu cầu → Đổi điện thoại</strong> để
            quản lý duyệt. Sau khi đổi, hệ thống khoá đổi tiếp trong 90 ngày.
          </p>
          <button
            type="button" className="nut-gui"
            onClick={() => onXong(Boolean(nhanVienHienTai()?.must_change_password))}
          >
            Tiếp tục với máy này
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="man-hinh dang-nhap">
      <div className="dang-nhap-tieu-de">
        <h1>Chấm công</h1>
        <p>Đăng nhập bằng mã nhân viên của bạn</p>
      </div>

      <form onSubmit={(e) => void gui(e)} className="form-dang-nhap">
        <label className="truong">
          <span>Mã nhân viên</span>
          <input
            type="text"
            value={ma}
            onChange={(e) => setMa(e.target.value)}
            autoCapitalize="characters"
            autoComplete="username"
            inputMode="text"
            placeholder="NV001"
            required
          />
        </label>

        <label className="truong">
          <span>Mật khẩu</span>
          <input
            type="password"
            value={matKhau}
            onChange={(e) => setMatKhau(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {loi && <p className="loi-dang-nhap" role="alert">{loi}</p>}

        <button
          type="submit"
          className="nut-gui"
          disabled={dangGui || !ma.trim() || !matKhau}
        >
          {dangGui ? 'Đang đăng nhập…' : 'Đăng nhập'}
        </button>
      </form>

      <p className="ghi-chu-dang-nhap">
        Quên mật khẩu? Liên hệ quản lý để đặt lại.
      </p>
    </div>
  )
}
